import noop from 'lodash/noop';
import type {
	InitAttrs,
	AnalyticsWebClient,
} from '@jira/platform__observability-product-analytics-web-client-types';

const SSRAnalyticsWebClient: AnalyticsWebClient = {
	initTime: 0,
	eventCount: 0,
	blockingDuration: 0,
	amplitudeSRAttributesInjector: noop,
	updateAmplitudeSRClient: noop,
	resetBlockingDuration: () => undefined,
	init: (attrs: InitAttrs) => !!attrs,
	sendEvent: noop,
	getInstance: () =>
		// @ts-expect-error - TS2741 - Property 'prototype' is missing in type '{}' but required in type 'AnalyticsWebClient'.
		new Proxy(
			{},
			{
				get: () => () => {
					// Analytics methods are inert during server rendering.
				},
			},
		),
	setSubProduct: noop,
	setUIViewedAttributes: noop,
	removeUIViewedAttribute: noop,
	setEmbeddedProduct: noop,
	clearUIViewedAttributes: noop,
	clearEmbeddedProduct: noop,
	stopApdexEvent: noop,
	setOriginTracingHandlers: noop,
	onNewSessionStarted: noop,
	setUpdateAmplitudeSRClient: noop,
	setAmplitudeSRAttributesInjector: noop,
	isInitialized: () => false,
};

export default SSRAnalyticsWebClient;
